<template>
	<transition
			appear
			:appear-active-class="$_inpCkb_styleInputCheckboxAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row no-gutters>
					<v-col>
						<template v-for="(answerOptionVals, answerOptionKey) in sortObject(contents[contentKey].options, 'order')">
							<v-row	:key="answerOptionKey"
									no-gutters>
								<v-col >
									<validation-provider
											:name="'InputCheckbox-' + contentKey + '-' + answerOptionKey"
											:rules="getValidationRules(contents[contentKey].rules)"
											v-slot="{ errors }">
										<v-checkbox
												v-model="$store.state.input.data[contentKey].answer[answerOptionKey].value"

												hide-details

												:background-color="$_inpCkb_styleCheckboxBackgroundColor"
												:color="$_inpCkb_styleCheckboxColor"
												:dark="$_inpCkb_styleCheckboxDark"
												:light="$_inpCkb_styleCheckboxLight"

												:label="$_inpCkb_langAnswerOptionText(answerOptionVals)"
												:error-messages="errors" />
									</validation-provider>	
								</v-col>
							</v-row>
						</template>
					</v-col>
				</v-row>
				<template v-if="$_inpCkb_langParamHint(contents[contentKey])">
					<v-row>
						<v-col>
							<span	class="hint_"
									v-text="$_inpCkb_langParamHint(contents[contentKey])" />
						</v-col>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputCheckbox',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpCkb_langParam() {
				const self_ = this;
				return contentVals => {
					if(self_.isFalse(contentVals)) { return null }
					return contentVals.params
				}
			},
			$_inpCkb_langParamHint() {
				const self_ = this;
				return contentVals => {
					const params_ = self_.$_inpCkb_langParam(contentVals)
					if(self_.isFalse(params_)) { return null }
					return self_.getLangsVal(params_.hint)
				}
			},
			$_inpCkb_langAnswerOptionText() {
				const self_ = this;
				return answerOptionVals => {
					const text_ = answerOptionVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			// style
			$_inpCkb_styleInputCheckbox() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputCheckbox')
				}
			},
			$_inpCkb_styleInputCheckboxAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpCkb_styleInputCheckbox()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpCkb_styleCheckbox() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'checkbox')
			},
			$_inpCkb_styleCheckboxBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpCkb_styleCheckbox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpCkb_styleCheckboxColor() {
				const self_ = this;
				const style_ = self_.$_inpCkb_styleCheckbox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpCkb_styleCheckboxDark() {
				const self_ = this;
				const style_ = self_.$_inpCkb_styleCheckbox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpCkb_styleCheckboxLight() {
				const self_ = this;
				const style_ = self_.$_inpCkb_styleCheckbox;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			}
		}
	}
</script>

<style scoped>
	.hint_ {
		font-size: small;
	}
</style>
